













































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import {
  Action,
} from 'vuex-class';


@Component({
  name: 'landing-footer',
})
export default class Footer extends Vue {
  @Action('auth/logout')
  private readonly logout!: (url?: string) => void;

  private get currentYear(): number {
    return new Date().getFullYear();
  }

  private handleLogout(): void {
    this.logout();
  }
}
